import { QuoteGetResponse } from '@lio/api-types';
import { PortalMessage } from '@components/portalMessage/PortalMessage';
import { PortalMessageType } from '@components/portalMessage/PortalMessageType.enum';
import Loading from '@components/Loading';
import { DownloadApplicationButton, yellowTextButtonStyles } from '@components/button/DownloadApplicationButton';
import { Box } from '@mui/material';

export const LapsedQuote = ({ quote }: { quote: QuoteGetResponse }) => {
  if (!quote) return <Loading />;

  return (
    <PortalMessage
      type={PortalMessageType.Expired}
      title={['This quote has expired.']}
      subtitle={[
        <span key='subtitle-text'>The desired effective date of this quote has passed and it has expired.</span>,
      ]}
      secondarySubtitle={[
        <Box key='secondary-text' component='span' sx={{ display: 'flex' }}>
          You may
          <DownloadApplicationButton
            quoteUpdatedDate={quote?.updatedAt}
            label='download your application'
            quoteId={quote.id}
            buttonProps={{
              color: 'secondary',
              variant: 'text',
              disableRipple: true,
              sx: yellowTextButtonStyles,
            }}
          />
          for your records.
        </Box>,
      ]}
      primaryBtnText='Message Underwriter'
      primaryBtnAction={`/quote/${quote.id}?viewReadOnly=true&sidebarItem=messages`}
      secondaryBtnText='Continue to your Homepage'
      secondaryBtnAction='/'
      quote={quote}
    />
  );
};
